function EditorIcon() {
  document.querySelectorAll('.arrow-link').forEach(setupLargeArrowLink);
  document.querySelectorAll('.simple-arrow-link').forEach(setupArrowLink);

  function setupLargeArrowLink(el) {
    let link;
    if (el.nodeName === 'A') {
      link = el;
    } else {
      link = el.querySelector('a');
    }

    if (!link) return;

    el.innerHTML = `<a class="combo-button focus" href="${link.href}">
      <span>${link.textContent}</span>
      <div>
        <svg role="img" aria-hidden="true" focusable="false" class="Icon Icon--arrow-right Icon--s">
          <use xlink:href="/v6-assets/img/icons/sprite.svg#arrow-right"></use>
        </svg>
      </div>
    </a>`;
  }

  function setupArrowLink(el) {
    let link;
    if (el.nodeName === 'A') {
      link = el;
    } else {
      link = el.querySelector('a');
    }

    if (!link) return;

    el.innerHTML = `
    <a href="${link.href}" class="Twi focus">
      <svg role="img" aria-hidden="true" focusable="false" class="Icon Icon--arrow-right Icon--s">
        <use xlink:href="/v6-assets/img/icons/sprite.svg#arrow-right"></use>
      </svg>
      <span>${link.textContent}</span>
    </a>`;
  }
}

export default EditorIcon;
